import { cookie } from '@playcastdotio/Cookie';
import { createPlayerPersistentId } from '@playcastdotio/CreateId';

export const getPersistentPlayerId = () => {
  const { get, set } = cookie();
  const id = get('playcast-player-id') || localStorage.getItem('playcast-player-id');
  if (id && !id?.startsWith('player_')) {
    // remake the id
    const newId = createPlayerPersistentId();
    set('playcast-player-id', newId);
    localStorage.setItem('playcast-player-id', newId);
    return newId;
  }
  if (id) return id;
  const searchParams = new URLSearchParams(window.location.search);
  const playerId = searchParams.get('id');
  if (playerId) {
    set('playcast-player-id', playerId);
    localStorage.setItem('playcast-player-id', playerId);
    return playerId;
  } else {
    const newId = createPlayerPersistentId();
    set('playcast-player-id', newId);
    localStorage.setItem('playcast-player-id', newId);
    return newId;
  }
};
